/***
 *
 *   SIGN UP STEP 2
 *   Signup form for account owners
 *   Step 1: create account
 *   Step 2: select plan and make payment
 *
 **********/

import React, { useContext } from "react";
import {
  Animate,
  AuthContext,
  Row,
  Card,
  PaymentForm,
  usePlans,
  Link,
  useNavigate,
  Event,
  InAppPricing,
  Grid
} from "components/lib";

export function SignupPlan(props) {
  const context = useContext(AuthContext);
  const navigate = useNavigate();
  const plans = usePlans();

  // read promo code from query string (e.g. /signup/plan?promo=SAVE20)
  const urlParams = new URLSearchParams(window.location.search);
  const promoFromUrl = urlParams.get("promo") || "";

  if (!plans.data) return false;

  return (
    <Animate type="pop">
      <Grid cols={2}>
      <Row title="Select Your Plan">
        <Card loading={false} restrictWidth center>
          <PaymentForm
            data={{
              plan: {
                label: "Plan",
                type: "select",
                options: plans.data.list,
                default: "free",
                required: true,
              },
              promo_code: {
                label: "Discount Code",
                type: "text",
                required: false,
                value: promoFromUrl,
                placeholder: "Enter discount code (optional)",
              },
              token: {
                label: "Credit Card",
                type: "creditcard",
                required: true,
              },
            }}
            url="/api/account/plan"
            method="POST"
            buttonText="Save Plan"
            callback={(res) => {
              // save the plan to context, then redirect
              Event("selected_plan", { plan: res.data.plan });
              context.update({
                plan: res.data.plan,
                subscription: res.data.subscription,
              });
              navigate(res.data.onboarded ? "/dashboard" : "/welcome");
            }}
          />

          <div className="mt-4">
            <Link url="/account/profile" text="Manage Your Account" />
          </div>
        </Card>
      </Row>
      <Row>
        <InAppPricing />
      </Row>
      </Grid>
    </Animate>
  );
}
